import { AccessDenied } from 'router/accessDenied'
import { useAuth } from 'context/authContext'
import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { FullScreenSpinner } from '../components/common/fullScreenSpinner'
import {
  COMPANY_PROFILE_ROUTE,
  componentRoutes,
  MY_PROFILE_ROUTE,
  SETTINGS_ROUTE
} from './routes'
import { NotFound } from './notFound'
import { isAccessDenied } from './isAccessDenied'

export function Router(): JSX.Element {
  const { permissions, loading } = useAuth()

  // Lazy load containers when the route is hit, this help reduce bundle size and "split" it
  // multiple different chunks. More information can be found here: https://reactjs.org/docs/code-splitting.html
  return (
    <Routes>
      <Route path='/' element={<Navigate to={MY_PROFILE_ROUTE} />} />
      <Route
        path={SETTINGS_ROUTE}
        element={<Navigate to={COMPANY_PROFILE_ROUTE} />}
      />
      {componentRoutes.map(
        ({ route, LazyContent, title, permissionWhitelist }) => (
          <Route
            path={route}
            element={
              <Suspense fallback={<FullScreenSpinner />}>
                {!loading &&
                  (isAccessDenied(permissions, permissionWhitelist) ? (
                    <AccessDenied pageTitle={title} />
                  ) : (
                    <LazyContent />
                  ))}
              </Suspense>
            }
            key={`router-element-${route}`}
          />
        )
      )}
      <Route path='*' element={<NotFound />} />
    </Routes>
  )
}
